import { JobInventoryData } from './types';

export const initialState: JobInventoryData = {
  dialog: false,
  actions: false,
  summary: { requested: '0', onTheWay: '0', atSite: '0', stillNeeded: '0' },
};
